export default {
  "path": "/demo/ButtonTabsDemo",
  "meta": {
    "name": "demo-tabs",
    "title": "tabs",
    "isComponentDoc": true,
    "category": "Basic"
  }
};